var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('Banner'),_c('Processes'),_c('Digitization'),_c('Accounting'),_c('Functionalities'),_c('Control'),_c('Team'),_c('HomeProject'),_c('HomeControl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }